import { useTheme } from "@emotion/react";
import { Box, Card, CardMedia, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { cardTitle, recipeCard, recipeCardMedia } from "../../styles/recipeStyles";
import MarkRecipeIcon from "../Common/Icons/MarkRecipeIcon";

const RecipeCard = ({ recipe }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const handleNavigate = () => {
    navigate(`/recipe/${recipe.id}`);
  };
  return (
    <Card sx={recipeCard(theme)} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onClick={handleNavigate}>
      {/* Favorite Button  */}
      <Box sx={{ position: "absolute", top: theme.spacing(1), right: theme.spacing(1) }} onClick={(e) => e.stopPropagation()}>
        <MarkRecipeIcon recipeId={recipe.id} />
      </Box>

      {/* Clickable Image & Title */}
      <CardMedia component="img" image={(recipe.images && recipe.images[0]) || "/assets/images/Placeholder.webp"} alt={recipe.title} sx={recipeCardMedia(theme)} />
      <Typography sx={cardTitle(theme)}>{recipe.title}</Typography>
    </Card>
  );
};

export default RecipeCard;
